import { getMatchCriterionLabelKey } from '../../../../RentalPortalMatch'
import { getApplicantFitCheckMissingCriteria } from '../ApplicantFitCheckBlockRequestRow'

import { MATCH_REQUEST_FORBIDDEN_PATTERNS } from './ApplicantFitCheckRequestModal.constants'

function getMatchRequestBullets({ match, t }) {
  return getApplicantFitCheckMissingCriteria(match)
    .map(criterion => `• ${t(getMatchCriterionLabelKey(criterion.key))}`)
    .join('\n')
}

export function getMatchRequestInitialValues({
  listingFacts,
  listingLabel,
  match,
  t,
}) {
  return {
    message: t('RentalPortal.MatchRequestMessageKey', {
      criteria: getMatchRequestBullets({ match, t }),
      facts: listingFacts,
      listing: listingLabel,
      salutation: t('RentalPortal.MatchRequestSalutationTokenKey'),
    }),
    subject: t('RentalPortal.MatchRequestSubjectKey', {
      listing: listingLabel,
    }),
  }
}

export function assertMatchRequestDraftIsClean(values) {
  if (process.env.NODE_ENV === 'development') {
    const draft = Object.values(values).join('\n')

    const leak = MATCH_REQUEST_FORBIDDEN_PATTERNS.find(pattern =>
      pattern.test(draft)
    )

    if (leak) {
      throw new Error(
        `Request-info draft violates BR-RP10-41: it matches ${leak}. The draft must carry no score, share, ranking or eligibility wording.`
      )
    }
  }
}
